import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Filter from "./Components/Filter";
import Mobile2 from "../../Common/Mobile2";
import FlatList from "./Components/FlatList";
import Search from "./Components/Search";
import Sort from "./Components/Sort";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useSearch } from "./Hooks";
import { useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import "./index.css";
function List({ isApp, isSearch }) {
  const [filterDialog, setFilterDialog] = useState(false);
  const {
    search,
    handleFilter,
    searchHandler,
    state,
    loading,
    getValue,
    clearFilters,
    filterDelete,
    getCategory,
    nextLoading,
  } = useSearch(isSearch);
  const loc = useLocation();
  const { categories } = useSelector(state => state);

  const toggleFilterDialog = status => {
    // if (!isApp) {
    setFilterDialog(status);
    // }
  };
  const btnHandler = () => {
    searchHandler({ ...search });
  };

  useEffect(() => {
    // if (!isApp) {
    if (!categories) {
      getCategory();
    }
    // }
  }, []);
  useEffect(() => {
    
    searchHandler({ ...search });
  }, [loc.pathname]);

  const renderSeo = () => {
    let res = {
      title: "لیست مجموعه ها | نیکوتن",
      description: "رزرو سالن استخر و باشگاه",
      content: "",
      seoKeyword: [],
    };
    if (!loading) {
      if (state.contentbox) {
        if (state.contentbox.seo && state.contentbox.seo) {
          res = {
            title: `${state.contentbox.seo.title} | نیکوتن`,
            description: state.contentbox.seo.seoDescription,
            seoKeyword: state.contentbox.seo.seoKeyword,
          };
        }
      }
    }
    return res;
  };

  const rendeKeyWords = () => {
    let res = "";
    if (!loading) {
      if (
        state.contentbox &&
        state.contentbox.seo &&
        state.contentbox.seo.seoKeyword &&
        Array.isArray(state.contentbox.seo.seoKeyword)
      ) {
        state.contentbox.seo.seoKeyword.map((key, count) => {
          if (state.contentbox.seo.seoKeyword.length - 1 == count) {
            res = res + key;
          } else {
            res = res + key + ", ";
          }
        });
        return res;
      }
    }
  };
  return (
    <>
      <Helmet>
        <title>{renderSeo()["title"]}</title>
        <meta name="description" content={renderSeo()["description"]} />
        <link rel="canonical" href={window.origin + loc.pathname} />
        <meta name="keywords" content={rendeKeyWords()} />

      </Helmet>


      {isApp &&
        <FlatList
          loading={loading}
          data={state}
          handleFilter={handleFilter}
          getValue={getValue}
          searchHandler={searchHandler}
          search={search}
          isApp={isApp}
          nextLoading={nextLoading}
        />
      }
      {!isApp &&
        <div id="list-item-page">
          <Search
            handleFilter={handleFilter}
            getValue={getValue}
            btnHandler={btnHandler}
            loading={loading}
            filterDelete={filterDelete}
          />

          <div className="container">
            <div className="row">
              <div className="col-3 d-none d-xl-block">
                <Filter
                  handleFilter={handleFilter}
                  getValue={getValue}
                  clearFilters={clearFilters}
                  search={search}
                  filterDelete={filterDelete}
                />
              </div>
              <div className="col-12 col-xl-9">
                <Sort
                  loading={loading}
                  count={state.total}
                  handleFilter={handleFilter}
                  getValue={getValue}
                  toggleFilterDialog={toggleFilterDialog}
                  filterDelete={filterDelete}
                />
                <FlatList
                  loading={loading}
                  data={state}
                  handleFilter={handleFilter}
                  getValue={getValue}
                  searchHandler={searchHandler}
                  search={search}
                />
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <Mobile2 />
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div
                  className="content"
                  style={{
                    padding: "20px 0px",
                    color: "#404040",
                    textAlign: "justify",
                    fontWeight: "400",
                    p: {
                      fontWeight: "400",
                    },
                  }}
                  dangerouslySetInnerHTML={{
                    __html: state && state.contentbox && state.contentbox.content,
                    // `<style>.h_iframe-aparat_embed_frame{position:relative;}.h_iframe-aparat_embed_frame .ratio{display:block;width:100%;height:auto;}.h_iframe-aparat_embed_frame iframe{position:absolute;top:0;left:0;width:100%;height:100%;}</style><div class="h_iframe-aparat_embed_frame"><span style="display: block;padding-top: 57%"></span><iframe src="https://www.aparat.com/video/video/embed/videohash/0dIpk/vt/frame" allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe></div>`,
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      }

      <Dialog
        // fullScreen
        style={{ overflowX: "hidden" }}
        scroll="paper"
        open={filterDialog}
        onClose={() => toggleFilterDialog(false)}
      >
        <DialogTitle id="scroll-dialog-title" style={{ width: "80vw" }}>
          <div className="">
            <CloseIcon onClick={() => toggleFilterDialog(false)} />
            <span className="h5 mx-3">فیلتر ها</span>
          </div>
        </DialogTitle>

        <DialogContent dividers style={{ overflowX: "hidden" }}>
          <Filter
            handleFilter={handleFilter}
            getValue={getValue}
            clearFilters={clearFilters}
            search={search}
            filterDelete={filterDelete}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}

export default List;
